import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getMonthlyOverviewAsync, getLearnerStatsAsync, getClientStatsAsync } from '../../Services/ReportService';
import Card from '../../Shared/Components/Card/Card';
import Header from '../../Shared/Components/Header/Header';

const Reports = () => {
    const [date, setDate] = useState(null);
    const history = useHistory();

    const getMonthlyOverview = async () => {
        await getMonthlyOverviewAsync(date)
    }

    const getStats = async () => {
        await getLearnerStatsAsync()
    }

    const getClientStats = async () => {
        await getClientStatsAsync()
    }

    const handleChange = evt => {
        setDate(evt.target.value);
    }

    const navigateTo = (path) => {
        history.push(path);
    }

    return (
        <>
            <Header heading="Reports Hub" subheading="Access all reporting and analytics" icon="stats-up" />
            <div className="container-fluid content">
                
                {/* AI Assistant Notice */}
                <Card>
                    <div className="alert alert-info mb-0" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <i className="lni lni-bot" style={{ fontSize: '2rem' }}></i>
                        <div>
                            <strong>💡 Tip:</strong> Ask Cosmo (the AI assistant) any questions about your data by clicking the Cosmo icon in the top navigation bar!
                        </div>
                    </div>
                </Card>

                {/* New Analytics & Reports */}
                <Card title="Analytics & Insights">
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <div className="card h-100 shadow-sm" style={{ cursor: 'pointer' }} onClick={() => navigateTo('/reporting/engagement-metrics')}>
                                <div className="card-body text-center">
                                    <i className="lni lni-pulse" style={{ fontSize: '3rem', color: '#28a745' }}></i>
                                    <h5 className="mt-3">Engagement Metrics</h5>
                                    <p className="text-muted">Track learner engagement and activity trends</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card h-100 shadow-sm" style={{ cursor: 'pointer' }} onClick={() => navigateTo('/reporting/group-performance')}>
                                <div className="card-body text-center">
                                    <i className="lni lni-users" style={{ fontSize: '3rem', color: '#ffc107' }}></i>
                                    <h5 className="mt-3">Group Performance</h5>
                                    <p className="text-muted">Compare and analyze group performance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-4 mb-3">
                            <div className="card h-100 shadow-sm" style={{ cursor: 'pointer' }} onClick={() => navigateTo('/reporting/user-insights')}>
                                <div className="card-body text-center">
                                    <i className="lni lni-bar-chart" style={{ fontSize: '3rem', color: '#17a2b8' }}></i>
                                    <h5 className="mt-3">User Insights</h5>
                                    <p className="text-muted">Demographics and signup analytics</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card h-100 shadow-sm" style={{ cursor: 'pointer' }} onClick={() => navigateTo('/reporting/learner-overview')}>
                                <div className="card-body text-center">
                                    <i className="lni lni-list" style={{ fontSize: '3rem', color: '#6f42c1' }}></i>
                                    <h5 className="mt-3">Learner Overview</h5>
                                    <p className="text-muted">Course enrollment overview by client</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <div className="card h-100 shadow-sm" style={{ cursor: 'pointer' }} onClick={() => navigateTo('/reporting/clients')}>
                                <div className="card-body text-center">
                                    <i className="lni lni-customer" style={{ fontSize: '3rem', color: '#dc3545' }}></i>
                                    <h5 className="mt-3">Client Reports</h5>
                                    <p className="text-muted">Monthly client activity and downloads</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>

                {/* Legacy Reports */}
                <Card title="Legacy Report Downloads">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <p className="text-muted">Download CSV reports for offline analysis</p>
                        </div>
                        <div className="col-md-4 mb-3">
                            <input type="date" className="form-control" value={date} onChange={handleChange} />
                        </div>
                        <div className="col-md-8 mb-3">
                            <button className="btn btn-primary mr-2 mb-2" onClick={getMonthlyOverview}>Monthly overview</button>
                            <button className="btn btn-primary mr-2 mb-2" onClick={getStats}>Gender Stats</button>
                            <button className="btn btn-primary mb-2" onClick={getClientStats}>Client stats</button>
                        </div>
                    </div>
                </Card>

                {/* Quick Links */}
                <Card title="Quick Access">
                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-muted mb-2">Note: Some reports require specific IDs as URL parameters:</p>
                            <ul className="text-muted small">
                                <li><strong>Learner Progress:</strong> /reporting/learner-progress/:learnerId</li>
                                <li><strong>Course Analytics:</strong> /reporting/course-analytics/:courseId</li>
                            </ul>
                        </div>
                    </div>
                </Card>
            </div>
        </>
    );
};

export default Reports;